import { render } from "./SliderPriceComponent.vue?vue&type=template&id=34619fb6"
import script from "./SliderPriceComponent.vue?vue&type=script&lang=js"
export * from "./SliderPriceComponent.vue?vue&type=script&lang=js"

import "./SliderPriceComponent.vue?vue&type=style&index=0&id=34619fb6&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__